export const h = {
	quantity: "Quantity",
	brand: "Brand",
	sku: "SKU",
	model: "Model",
	addCart: "Add To Cart",
	buyNow: "Buy Now",
	productDetail: "Product Detail",
	attribute: "Attribute",
	quantityExits: "In Stock",
	quantityNone: "Out Stock",

	// 账单页面
	email: "Email",
	errorEmail: "Please enter a valid email address",
	contact: 'Contact information',
	sippingAddress: 'Delivery address',
	name: "Name",
	nameError: "Please enter your name.",
	address1: "Address1",
	address1Error: "Please enter the address1",
	address2: "Address2",
	emailCode: "postcode",
	phone: "Phone Number",
	city: "City",
	cityError: "Please enter the city",
	country: "Country",
	countryError: "Please enter the country",
	province: "province",
	provinceError: "Please enter the province",
	payWay: "Payment method",
	sendWay: "Delivery method",
	loginText: "Log in / Register",
	cartNum: "Total items in the shopping cart",
	orderRemarks: "Order Remarks",
	discountCode: "Please enter the discount code",
	apply: "apply",
	submitOrder: "Submit order",

	classify: "Category",
	price: "Price",
	allNum: "Total",
	defaultTit: "Default",
	salesLowToHigh: "Sales (Low - High)",
	salesHighToLow: "Sales (High - Low)",
	nameAtoZ: "Name (A - Z)",
	nameZtoA: "Name (Z - A)",
	priceLowtoHeight: "Price (Low - High)",
	priceHeighttoLow: "Price (High - Low)",
	selectClassfiy: "Select Category",
	goodCart: "Shopping Cart",
	checkout: "Checkout",
	pay: "Payment",
	goods: "Product",
	num: "Quantity",
	total: "Subtotal",
	action: "Action",
	del: "Delete",
	priceTotal: "Total",
	all: "All",
	selectd: "Selected",
	goCheckout: "Proceed to Checkout",
	linkGoods: "Related Products",
	noData: "No Data Available",
	myOrder: "My Orders",
	changeUserInfo: "Edit Personal Information",
	changePassword: "Change Password",
	myAddress: "My Addresses",
	myWishlist: "My Wishlist",
	myRmas: "My After-Sales",
	userCommission: "Member Commission",
	commissionUsers: "Member Relations",
	loginOut: "Logout",
	orderId: "Order Number",

	lookDetail: "View Details",
	saleService: "Request After-Sales Service",
	confirmReceivedGoods: "Confirm Receipt",
	goPay: "Proceed to Payment",
	cancelOrder: "Cancel Order",

	orderDetail: "Order Details",
	created_at: "Created At",
	status_format: "Order Status",
	total_format: "Order Amount",
	payment_method_name: "Payment Method",
	shipping_method_name: "Shipping Method",

	addressInfo: "Address Information",
	name: "Name",
	address: "Address",
	payGoods: "Ordered Products",

	sendCompany: "Courier Company",
	sendNum: "Tracking Number",
	updateTime: "Updated At",
	memo: "Remarks",
	payOrderAddress: "Billing Address",
	allOrder: "All Orders",
	waitPay: "Pending Payment",
	waitSend: "Pending Shipment",
	waitReceiving: "Pending Receipt",
	completed: "Completed",
	confirm: "Confirm",
	tips: "Tips",
	cancel: "Cancel",
	changeHeadImg: "Change Avatar",
	uploadTit: "Upload JPEG or PNG image. Recommended size: 300 x 300.",
	imgSizeTips: "Avatar image size cannot exceed 2 MB!",
	imgTypeTips: "Avatar image must be in JPG/PNG format!",
	serviceType: "Service Type",
	returnNum: "Return/Exchange Quantity",
	isOpend: "Is the packaging opened?",
	returnReason: "Return/Exchange Reason",
	yes: "Yes",
	no: "No",
	returnGoods: "Return",
	exchange: "Exchange",
	repair: "Repair",
	reissue: "Resend Product",
	refund: "Refund Only",
	returnNumError: "Please enter the return/exchange quantity",

	oldPassword: "Old Password",
	newPassword: "New Password",
	confirmNewPassword: "Confirm New Password",

	wishlist: "Remove from Wishlist",
	look: "View",
	opendPkg: "Packaging Opened",
	img: "Image",
	afterSales: "After-Sales Details",

	balance: "Available Balance",
	waitAmount: "Pending Settlement",
	withdrawaled: "Withdrawn",
	withdrawal: "Withdraw",
	allCommission: "Total Commission",
	startTime: "Start Time",
	endTime: "End Time",
	search: "Search",

	rebateLevel: "Rebate Level",
	CommissionRate: "Commission Rate",
	commission: "Commission",
	settlementStatus: "Settlement Status",
	time: "Time",
	WithdrawalAmount: "Withdrawal Amount",
	peleaseSelect: "Please Select",
	withdrawalUser: "Withdrawal Account",
	peleaseIpt: "Please Enter",
	submitSuccess: "Submitted Successfully",
	shareLink: "Share Link",
	superior: "My Direct Superior",
	wu: "None",
	subordinate: "My Subordinates",
	addTime: "Join Date",
	userAccount: "Account",
	recommendationCode: "Referral Code",
	copySuccess: "Copied Successfully",
	subPay: "Submit Payment",
	iptCardholder_Name: "Please enter cardholder name",
	copy: "copy",


	"home": "Home",
	"categoriesPage": "Categories",
	"brandsPage": "Brands",
	"brandsPageList": "Brand Products",
	"productsPage": "Products",
	"wishlistPage": "My Wishlist",
	"accountPage": "My Orders",
	"cartsPage": "Shopping Cart",
	"checkoutPage": "Checkout",
	"passwordPage": "Change Password",
	"editPage": "Edit Information",
	"addressesPage": "Edit Address",
	"rmasPage": "Membership Relations",
	"commissionPage": "Member Commission",
	"success_order_checkoutPage": "Order Payment",
	"page_categoriesPage": "Article Categories",
	"userloginPage": "Login",
	"pagesPage": "Articles",

	hotGoods: "Popular Products",
	newGoods: "New Products",
	visitGoods: "Most Viewed",
	allGoods: "All Products",
	evaluation: "Reviews",

	"first_name": "Last name",
	"first_nameError": "Please enter your last name",
	"last_name": "First name",
	"last_nameError": "Please enter your first name",

	"comment": "Content",
	"noContent": "No comments yet",
	"author": "Author",
	"scoreNum": "Rating",
	"commentTit": "Comments",

	send: "Send",
	noPayWay: "No available payment methods",
	noTransportation: "No available transportation methods",

	"tkyouorder": "Thank you for your order",
	"orderDate": "Order Date",
	"ordeAmount": "Order Amount",
	"paymentAddress": "Payment Address",
	"zipCode": "Zip Code",
	customizationFee: "Customization fee"

}